import { DateAsString, SporsmalType } from '../../types/generated-types';
import { BesvartSporsmal, CurrentSporsmal } from '../reducer/current-steg';
import { Datosporsmal } from '../reducer/sporsmalsflyt-types';

export interface CurrentDatosporsmal {
    type: SporsmalType.Dato;
    sporsmal: Datosporsmal;
    dato?: DateAsString;
}

export interface BesvartDatosporsmal {
    type: SporsmalType.Dato;
    sporsmal: Datosporsmal;
    dato: DateAsString;
}

export const isDatoSporsmal = (currentSporsmal: CurrentSporsmal): currentSporsmal is CurrentDatosporsmal =>
    currentSporsmal.type === SporsmalType.Dato;

export const isSkadedatoSporsmal = (besvartSporsmal: BesvartSporsmal): besvartSporsmal is BesvartDatosporsmal =>
    besvartSporsmal && besvartSporsmal.type === SporsmalType.Dato && besvartSporsmal.sporsmal.id === 'Skadedato';

export const isBesvartDatosporsmal = (currentSporsmal: CurrentSporsmal): currentSporsmal is BesvartDatosporsmal =>
    currentSporsmal.type === SporsmalType.Dato && !!currentSporsmal.dato;

export const updateCurrentDatoSporsmal = (currentSporsmal: CurrentSporsmal, dato?: DateAsString): CurrentSporsmal => {
    if (isDatoSporsmal(currentSporsmal)) {
        return {
            ...currentSporsmal,
            dato,
        };
    }
    return currentSporsmal;
};
